import * as Sentry from '@sentry/gatsby'

const CHUNK_ERROR_RE = /Loading chunk [\w-]+ failed|Loading CSS chunk|ChunkLoadError|error loading dynamically imported module|Importing a module script failed/i

const RELOAD_KEY = 'oky:chunkReloadAt'
const RELOAD_WINDOW_MS = 10000

export const isChunkError = error => {
  if (!error) {
    return false
  }

  if (typeof error === 'string') {
    return CHUNK_ERROR_RE.test(error)
  }

  if (error.name === 'ChunkLoadError') {
    return true
  }

  return CHUNK_ERROR_RE.test(error.message || '')
}

const canReloadNow = () => {
  try {
    const last = Number(window.sessionStorage.getItem(RELOAD_KEY)) || 0
    if (Date.now() - last < RELOAD_WINDOW_MS) {
      return false
    }
    window.sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
    return true
  } catch {
    return true
  }
}

export const reloadOnceForChunkError = error => {
  if (typeof window === 'undefined') {
    return false
  }

  const recovered = canReloadNow()

  Sentry.captureException(
    error instanceof Error ? error : new Error(String(error)),
    { tags: { chunkLoadError: true, recovered } },
  )

  if (recovered) {
    window.location.reload()
  }

  return recovered
}
